import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-bsswitch',
	templateUrl:'./BSSwitchPage.html',
	styles: [],
	styleUrls:['./BSSwitchPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSSwitchPage
{
	mdContent_160 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.buttons.switches.BSSwitch;
\`\`\``;
	mdContent_161 = `\`\`\`java
new BSCustomSwitchGroup<>()
\`\`\``;
	mdContent_162 = `\`\`\`java
new BSCustomSwitchGroup<>(String label)
\`\`\``;
	mdContent_163 = `\`\`\`java
var switchGroup = new BSCustomSwitchGroup<>("Enable Notifications");
var input = new InputCheckBoxType<>();
switchGroup.setInput(input);
input.bind("notifications");
\`\`\``;
}
